import NoOrderCard from "./noOrderCard";

function OrderList({children}) {
    return (
        <div className="orders">
            {
                children.length === 0 ? (<NoOrderCard/>) : children
            }
        </div>
    )
}

export default OrderList